const EMPTY_REVIEW_HEADINGS = ['no reviews yet'];

function normalizeText(value) {
  return value.replace(/\s+/g, ' ').trim().toLowerCase();
}

function replaceEmptyStateHeading(heading) {
  if (!EMPTY_REVIEW_HEADINGS.includes(normalizeText(heading.textContent || ''))) return;

  const replacement = document.createElement('p');

  for (const attribute of heading.attributes) {
    replacement.setAttribute(attribute.name, attribute.value);
  }

  while (heading.firstChild) {
    replacement.appendChild(heading.firstChild);
  }

  heading.replaceWith(replacement);
}

function cleanEmptyReviewHeadings(root = document) {
  root.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(replaceEmptyStateHeading);
}

cleanEmptyReviewHeadings();

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof Element)) continue;

      if (node.matches('h1, h2, h3, h4, h5, h6')) {
        replaceEmptyStateHeading(node);
      }

      cleanEmptyReviewHeadings(node);
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });